// Golem archetype (MOB-2 golem: iron/snow — constructed defenders, M13.1). PURE.
//
// A player-built golem patrols where it was made and hunts the nearest hostile
// monster within range, striking it with a heavy melee toss (iron golem). Golems
// never target players; the snow-golem override swaps melee for a snowball.
import { GOLEM } from '../../config';
import type { MobDef } from '../../registry/schemas';
import type { Entity, MobContext } from '../entity';
import { wander, meleeEntity } from './shared';

/** True if `e` is a live hostile monster a golem should attack. */
export function isHostileTarget(e: Entity): boolean {
  return !e.removed && e.category === 'monster';
}

/** Acquire (or keep) the nearest hostile monster; returns it, or null. */
export function golemTarget(e: Entity, ctx: MobContext): Entity | null {
  const held = ctx.sys.byId(e.targetEntityId);
  if (held && isHostileTarget(held)) return held;
  const next = ctx.sys.nearestEntity(e, GOLEM.TARGET_RANGE, isHostileTarget);
  e.targetEntityId = next ? next.id : -1;
  return next;
}

export function golem(e: Entity, def: MobDef, ctx: MobContext): void {
  const target = golemTarget(e, ctx);
  if (target) {
    meleeEntity(e, def, ctx, target, GOLEM.TOSS_V); // iron golem launches its victim
    return;
  }
  wander(e, ctx, def);
}
